import jwtDecode from 'jwt-decode';

const getters = {
  isAuthenticated: (state) => !!state.token,
  jwt: (state) => (state.token ? jwtDecode(state.token) : {}),
  customer: (state) => state.customer,
  orders: (state) => state.orders,
  incadeaOrders: (state) => state.incadeaOrders,
  order: (state) => state.order,
  shoppingList: (state) => state.shoppingList,
};

export default getters;
